import { FC } from 'react';
import { useParams } from 'react-router';

import { AppCardList } from '@/common/components';

import { AppRoutes, BaseQueryParams } from '@/common/interfaces';
import { useGetLayoutsPageQuery } from '@/modules/Pages/queries';

interface Props {
  items: BaseQueryParams<typeof useGetLayoutsPageQuery>['data'];
}

export const PageLayoutsOverviewView: FC<Props> = ({ items }) => {
  const layoutId = useParams()['*']?.replace('layouts/', '').replace('/edit', '').replace('/create', '');

  return (
    <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 55px - 56px - 48px - 48px)' }}>
      <AppCardList
        headerTitle="Макети"
        rowKey="id"
        titleKey="name"
        selectedKey={ layoutId }
        navigateTo={ ({ id, site: { id: siteId } }) => ({
          to: AppRoutes.PageLayoutsById.replace(':siteId', siteId).replace(':layoutId', id),
          replace: layoutId === id,
        }) }
        list={ items }
      />
      { /* <List
        dataSource={ items }
        renderItem={ (item) => (
          <List.Item>
            <Link
              style={{ width: '100%' }}
              to={ AppRoutes.PageLayoutsById.replace(':siteId', item.site.id).replace(':layoutId', item.id) }
            >
              <Card title={ item.name } extra={ <>dwdwds</> }/>
            </Link>
          </List.Item>
        ) }
      /> */ }
    </div>
  );
};
